'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const DetailsItem = require('./DetailsItem');
const DetailsMaterialAndTechniques = require('./DetailsMaterialsAndTechniques');
const DetailsDimensions = require('./DetailsDimensions');
const DetailsMultiline = require('./DetailsMultiline');
const findNameSpace = require('find-namespace-value');
const detailsConstants = require('../../constants/detailsConstants.es.js');

class DetailsItems extends ContextComponent {
    constructor(props) {
        super(props);
    }

    /**
     * This component takes three props
     *   detailsConfig - see definition in detailsConfig {@link newPdp/details/detailsConfig}
     *   detailsTitles - see definition for detailsTitles in ItemStore {@link newPdp/stores/ItemStore}
     *   details       - see defintion for getDetails in ItemStore {@link newPdp/stores/ItemStore}
     *
     * And in render calls the array map method on detailsConfig, at each step using an object
     * in the array to determine what component to use to render a detail as well as what information
     * to pass to that component from detailsTitles and details.
     */
    render() {
        const details = this.props.detailsConfig
            .map(config => {
                return {
                    title: findNameSpace(config.title, this.props.detailsTitles),
                    contents: findNameSpace(config.contents, this.props.details),
                    component: config.component,
                    gaLabel: config.gaLabel,
                    testName: config.testName,
                };
            })
            .filter(results => !!(results.title && results.contents))
            .map((results, i) => {
                if (
                    results.component &&
                    results.component ===
                        findNameSpace('components.materialsAndTechniques', detailsConstants)
                ) {
                    return (
                        <DetailsMaterialAndTechniques
                            {...results}
                            key={i}
                            isPrintPage={this.props.isPrintPage}
                        />
                    );
                } else if (
                    results.component &&
                    results.component === findNameSpace('components.dimensions', detailsConstants)
                ) {
                    return <DetailsDimensions {...results} key={i} />;
                } else if (
                    results.component &&
                    results.component === findNameSpace('components.multiline', detailsConstants)
                ) {
                    return (
                        <DetailsMultiline
                            {...results}
                            key={i}
                            isPrintPage={this.props.isPrintPage}
                        />
                    );
                } else {
                    return (
                        <DetailsItem {...results} key={i} isPrintPage={this.props.isPrintPage} />
                    );
                }
            });

        const detailsSize = details.length;
        const columnCount = detailsSize <= 5 ? 1 : 4;
        const itemsPerColumn = Math.ceil(detailsSize / columnCount);
        const columns = [];

        // Split details into columns with length of `itemsPerColumn`
        details.forEach((detail, index) => {
            const columnNumber = Math.floor(index / itemsPerColumn);

            if (!columns[columnNumber]) {
                columns[columnNumber] = [detail];
            } else {
                columns[columnNumber].push(detail);
            }
        });

        return (
            <div className="pdp-details-entries">
                <div className="rowFlex">
                    {columns.map((columnItems, key) => (
                        <ul key={key} className="pdp-details-entries-column colXs12 colLg6 colXl3">
                            {columnItems}
                        </ul>
                    ))}
                </div>
            </div>
        );
    }
}

DetailsItems.defaultProps = {
    isPrintPage: false,
};

DetailsItems.propTypes = {
    details: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    detailsConfig: PropTypes.array.isRequired,
    isPrintPage: PropTypes.bool,
};

module.exports = DetailsItems;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsItems.jsx